import React, { FC, MouseEventHandler, useEffect, useState } from "react";
import { UiCheckboxProps } from "./types";
import styles from "./ui-checkbox.module.css";

const UiCheckbox: FC<UiCheckboxProps> = ({
  active,
  className,
  size = 20,
  onChange,
  autoCheck = true
}) => {
  const [isActive, setIsActive] = useState(active);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (autoCheck) setIsActive((a) => !a);
    onChange(!isActive, e);
  };

  useEffect(() => {
    if (active !== isActive) setIsActive(active);
  }, [active]);

  return (
    <div
      className={`${styles.uiCheckbox} ${className} ${
      isActive && styles.active
      }`}
      onClick={(e) => {
        handleClick(e);
      }}
      style={{ width: `${size}px`, height: `${size}px` }}>

      <span
        className={`${styles.icon} icon-check`}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          fontSize: `${size - 2}px`
        }} />

    </div>);

};

export default UiCheckbox;